import React from "react";
import { useTranslation } from "react-i18next";
import "./ListStatusDisplay.css";

export const ListStatusDisplay = ({ status, withSquare = true }) => {
  const { t } = useTranslation();
  return (
    <div className="ListStatusDisplay__status">
      {withSquare && (
        <div
          className="ListStatusDisplay__status--indicator"
          style={{
            backgroundColor:
              status.toLowerCase() === "active" ||
              status.toLowerCase() === "aktiv"
                ? "#56B267"
                : "#D69D23",
          }}
        ></div>
      )}
      <div className="ListStatusDisplay__status--text">{t(status)}</div>
    </div>
  );
};
